import {
    faDoorOpen,
    faEdit,
    faExchangeAlt,
    faEyeSlash,
    faRetweet,
    faTimes,
    faUser,
    faUserAltSlash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import Swal from "sweetalert2";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useModuloInfo } from "../../../../Context/ModuloInfo";
import { useUserInfor } from "../../../../Context/User";
import {
    RemoverAtendimentoDoUsuarioController,
    RemoverAtendimentoDoUsuarioAcompanhamentoController,
} from "../../../../Controllers/AtendimentoCliente/Atendimento/AtendimentoControllers";
import { AtenderAtendimentoController } from "../../../../Controllers/Geral/Atendimentos/AtendimentosController";
import { IAtendimentoExtraDetalhado } from "../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import ModalComponent from "../../../Modais";
import { IComponentModal } from "../../../Modais/IModalComponent";
import AlterarEtapaCaso from "../../AlterarEtapaCaso";
import EditarAtendimento from "../../Atendimento/AtendimentoDetalhado/EditarAtendimento";
import { CancelarCaso } from "../../Atendimento/CancelarCaso";
import { ReabrirCaso } from "../../Atendimento/ReabrirCaso";
import TransferirAtendimento from "../../Atendimento/TransferirAtendimento";

interface IMenuAcoesDoCasoProps {}

export default function MenuAcoesDoCaso(props: IMenuAcoesDoCasoProps) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const { Atendimento, updateAtendimento, bloquearInteracoes, TIPO_CASO } =
        useAtendimentoPage();

    const AtendimentoPage = useAtendimentoPage();

    // eslint-disable-next-line
    const AtendimentoAssistencia =
        AtendimentoPage?.Atendimento as IAtendimentoExtraDetalhado;

    const { id } = useModuloInfo();

    const { FUNCOES } = useUserInfor().UserInfor;

    const mostrarBotaoReabrir =
        bloquearInteracoes &&
        TIPO_CASO !== "Cobranca" &&
        FUNCOES.some((f) => f.NM_FUNCAO === "ADM_CASO_REABERTURA");

    const possuiBotaoParaMostrar = mostrarBotaoReabrir || !bloquearInteracoes;

    if (possuiBotaoParaMostrar) {
        return (
            <div className="dropleft dropdown-inline m-2">
                <button
                    type="button"
                    className="btn btn-hover-light-primary btn-sm btn-icon"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    disabled={AtendimentoAssistencia.FL_CASO_PARALIZADO}
                >
                    <i className="ki ki-bold-more-ver"></i>
                </button>
                <div className="dropdown-menu">
                    {!bloquearInteracoes && (
                        <>
                            <span
                                className="dropdown-item d-flex align-items-center g-2 text-primary"
                                role="button"
                                onClick={() => {
                                    setModal({
                                        Component: () => (
                                            <EditarAtendimento
                                                setShow={setShow}
                                            />
                                        ),
                                        headerComponent: "Editar Atendimento",
                                    });
                                    setShow(true);
                                }}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                                Editar
                            </span>
                            <span
                                className="dropdown-item d-flex align-items-center g-2 text-success"
                                role="button"
                                onClick={() => {
                                    setModal({
                                        Component: () => (
                                            <TransferirAtendimento
                                                ID_USUARIO={
                                                    Atendimento!
                                                        .ID_USUARIO_RESPONSAVEL
                                                }
                                                ID_CASO={Atendimento!.ID_CASO}
                                                ID_TIPO_CASO={id ?? 0}
                                                setShow={setShow}
                                                update={() => {
                                                    updateAtendimento();
                                                }}
                                                ID_USUARIO_ACOMPANHAMENTO={
                                                    Atendimento!
                                                        .ID_USUARIO_ACOMPANHAMENTO
                                                }
                                            />
                                        ),
                                        IconHeader: faExchangeAlt,
                                        headerComponent:
                                            "Transferir Atendimento",
                                    });
                                    setShow(true);
                                }}
                            >
                                <FontAwesomeIcon icon={faExchangeAlt} />
                                Transferir Atendimento
                            </span>

                            {!!Atendimento!.ID_USUARIO_RESPONSAVEL ? (
                                <span
                                    className="dropdown-item d-flex align-items-center g-2 text-warning"
                                    role="button"
                                    onClick={() => {
                                        Swal.fire({
                                            title: `Deseja remover o vínculo de ${
                                                Atendimento!
                                                    .DS_USUARIO_RESPONSAVEL
                                            } a este atendimento?`,
                                            icon: "info",
                                            buttonsStyling: false,
                                            confirmButtonText:
                                                "<i class='la la-check'></i> Sim!",
                                            showCancelButton: true,
                                            cancelButtonText:
                                                "<i class='la la-thumbs-down'></i> Não",
                                            customClass: {
                                                confirmButton:
                                                    "btn btn-outline-success",
                                                cancelButton: "btn btn-default",
                                            },
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                RemoverAtendimentoDoUsuarioController(
                                                    Atendimento!.ID_CASO
                                                ).then(() => {
                                                    updateAtendimento();
                                                });
                                            }
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon icon={faUserAltSlash} />
                                    Remover Atendente
                                </span>
                            ) : (
                                <span
                                    className="dropdown-item d-flex align-items-center g-2 text-warning"
                                    role="button"
                                    onClick={() => {
                                        AtenderAtendimentoController(
                                            Atendimento!.ID_CASO
                                        ).then(() => updateAtendimento());
                                    }}
                                >
                                    <FontAwesomeIcon icon={faUser} />
                                    Atender
                                </span>
                            )}
                            {Atendimento!.ID_USUARIO_ACOMPANHAMENTO &&
                                FUNCOES.some(
                                    (f) =>
                                        f.NM_FUNCAO ===
                                        "ADM_GERENCIAR_ATENDENTES"
                                ) && (
                                    <span
                                        className="dropdown-item d-flex align-items-center g-2 text-warning"
                                        role="button"
                                        onClick={() => {
                                            RemoverAtendimentoDoUsuarioAcompanhamentoController(
                                                Atendimento!.ID_CASO
                                            ).then(() => updateAtendimento());
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faEyeSlash} />
                                        Remover Acompanhamento
                                    </span>
                                )}

                            {FUNCOES.some(
                                (f) => f.NM_FUNCAO === "CANCELA_CASO"
                            ) && (
                                <span
                                    className="dropdown-item d-flex align-items-center g-2 text-danger"
                                    role="button"
                                    onClick={() => {
                                        setShow(true);
                                        setModal({
                                            headerComponent:
                                                "Cancelar Atendimento",
                                            IconHeader: faTimes,
                                            Component: () => (
                                                <CancelarCaso
                                                    setShow={setShow}
                                                    Atendimento={Atendimento!}
                                                />
                                            ),
                                            size: "lg",
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon icon={faTimes} />
                                    Cancelar Atendimento
                                </span>
                            )}
                        </>
                    )}
                    {mostrarBotaoReabrir && (
                        <span
                            className="dropdown-item d-flex align-items-center g-2 text-success"
                            role="button"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: "Reabrir Atendimento",
                                    IconHeader: faDoorOpen,
                                    Component: () => (
                                        <ReabrirCaso
                                            setShow={setShow}
                                            ID_CASO={Atendimento!.ID_CASO}
                                        />
                                    ),
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faDoorOpen} />
                            Reabrir Atendimento
                        </span>
                    )}
                    {FUNCOES.some(
                        (f) => f.NM_FUNCAO === "ADM_EDITAR_ETAPA_CASO"
                    ) && (
                        <span
                            className="dropdown-item d-flex align-items-center g-2 text-success"
                            role="button"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: "Alterar Etapa",
                                    IconHeader: faRetweet,
                                    Component: () => (
                                        <AlterarEtapaCaso
                                            setShow={setShow}
                                            updateAtendimento={() =>
                                                updateAtendimento()
                                            }
                                        />
                                    ),
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faRetweet} />
                            Alterar Etapa
                        </span>
                    )}
                </div>

                <ModalComponent
                    setShow={setShow}
                    show={show}
                    ModalComponent={modal}
                />
            </div>
        );
    } else return null;
}
